import {
  STATUS,
  CRF_NO,
  CREATION_DATE,
  EXPECTED_COMPLETION_DATE,
  DUE_DATE,
  TOTAL_NET_PRICE,
  DEPARTMENT,
  PROJECT,
  ID,
  REQUESTOR,
  REQUEST_TYPE,
  VENDOR,
  RELEASING_CENTER,
  PO_NUMBER,
  DEPARTMENT_APPROVER,
  ACCOUNTING_APPROVER,
  ACCOUNTING_MANAGER,
  PARTICULARS,
  SUB_PROJECT,
  PROJECT_CLASSES
} from '../types'
export default {
  [ID]: 'ID',
  [CRF_NO]: 'CRF #',
  [REQUESTOR]: 'Requestor',
  [REQUEST_TYPE]: 'Request type',
  [CREATION_DATE]: 'Date created',
  [EXPECTED_COMPLETION_DATE]: 'Expected completion date',
  [DUE_DATE]: 'Due date',
  [PO_NUMBER]: 'PO #',
  [TOTAL_NET_PRICE]: 'Amount requested ',
  [VENDOR]: 'Vendor name',
  [DEPARTMENT]: 'Department',
  [PROJECT]: 'Project',
  [RELEASING_CENTER]: 'Releasing center',
  [STATUS]: 'Status',
  [DEPARTMENT_APPROVER]: 'Department head',
  [ACCOUNTING_APPROVER]: 'Accounting staff',
  [ACCOUNTING_MANAGER]: 'Accounting manager',
  [PARTICULARS]: 'Particulars',
  [SUB_PROJECT]: 'Sub project',
  [PROJECT_CLASSES]: 'Total project classes'
}
